export default class DestinationsClient {
    constructor(apiClient) {
        this.apiClient = apiClient;
        this.getDestinations = this.getDestinations.bind(this);
        this.getDestination = this.getDestination.bind(this);
        this.postDestination = this.postDestination.bind(this);
        this.putDestination = this.putDestination.bind(this);
    }
    getDestinations(config) {
        return this.apiClient.get('/v3/destinations', config);
    }
    getDestination(id, config) {
        return this.apiClient.get(`/v3/destinations/${id}`, config);
    }
    postDestination(data, config) {
        return this.apiClient.post('/v3/destinations', data, config);
    }
    putDestination(id, data, config) {
        return this.apiClient.put(`/v3/destinations/${id}`, data, config);
    }
}
